// extracted by mini-css-extract-plugin
export default {"container":"TOSPage_container__lwT3U","bold":"TOSPage_bold__gFCE6","liHeading":"TOSPage_liHeading__0Tn-5"};